<div class="import-popup-container">
  <div class="close-icon" (click)="clickClose()">
    <i class="pi pi-times"></i>
  </div>

  <div *ngIf="mode === 'upload'">
    <p class="text-color-secondary">
      {{ downloadMessage | translate }}<br />

      <a
        class="file-link underline cursor-pointer mt-1"
        [href]="templateImportUrl"
      >
        {{ templateName | translate }}
      </a>
    </p>

    <div *ngIf="isOptionSelectable" class="mb-3 mt-2">
      <div class="font-bold text-l mb-3">
        {{ SELECTION_TEXT | translate }}
      </div>

      <app-base-dropdown
        [options]="selectionOptions"
        (onItemSelected)="onOptionSelected($event)"
        [defaultValue]="selectedValue"
        [disabled]="true"
        [fieldControl]="getSelectedValueFormControl()"
      >
      </app-base-dropdown>
    </div>

    <div class="card surface-100 border-round p-4">
      <div class="mb-3 mt-2">
        <div class="font-bold text-xl mb-3">
          {{ 'UPLOAD_FILE' | translate }}
        </div>
        <div class="font-medium text-base">
          {{ FILE_ATTACHMENT_IMPORT_TEXT | translate }}
        </div>

        <app-files-uploader
          class="h-17rem"
          [maxFiles]="1"
          [acceptType]="[acceptType]"
          [maxFileSize]="5"
          [multipleSelect]="false"
          (onFileSelected)="onFileSelected($event)"
          [selectedFiles]="selectedAttachments || []"
          (errorType)="handleUploadError($event)"
          [silentErrors]="['INVALID_FILE_SIZE']"
        >
        </app-files-uploader>
      </div>
      <div class="btn-group">
        <app-cancel-button
          ngClass="mr-2"
          data-testid="btnGoBack"
          (onClick)="onCancel()"
          [isChanged]="selectedAttachments.length > 0"
        >
        </app-cancel-button>
        <app-base-button
          [label]="buttonText?.proceedBtn || 'PROCEED'"
          (onClick)="processData($event)"
          [disabled]="selectedAttachments.length === 0"
        >
        </app-base-button>
      </div>
    </div>
  </div>

  <div *ngIf="mode === 'process'">
    <div
      class="pt-5 p-5 flex justify-content-center gap-4 border-primary border-solid border-1 border-round-3xl surface-ground flex-column align-items-center mt-4"
    >
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
      <div class="text-lg font-bold line-height-4">
        Please wait for a moment. Checking file...
      </div>
    </div>
  </div>

  <div *ngIf="mode === 'submit'">
    <div class="noti-card submit my-3">
      <i class="pi pi-check-circle mr-1 mt-1"></i>
      <div>
        {{ 'PASSED_IMPORT_WARNING' | translate : { number: totalRecords } }}
      </div>
    </div>
    <div class="font-normal text-sm ml-auto m-3">
      {{ 'PASSED_IMPORT' | translate }}
    </div>
    <div class="flex m-3">
      <app-base-button
        class="ml-auto mr-3"
        label="CANCEL"
        [outlined]="true"
        (onClick)="onCancel()"
      ></app-base-button>
      <app-base-button
        [label]="buttonText?.submitBtn || 'SUBMIT'"
        iconName="pi pi-send"
        (onClick)="submit()"
        [disabled]="disableSubmit"
      ></app-base-button>
    </div>
  </div>

  <div *ngIf="mode === 'warning'">
    <div class="noti-card warning my-3">
      <i class="pi pi-info-circle mr-1 mt-1"></i>
      <div>
        {{ 'FAILED_IMPORT_WARNING' | translate : { number: totalFailRecords } }}
      </div>
    </div>
    <div class="font-normal text-sm ml-auto m-3">
      <p
        [innerHTML]="
          'FAILED_IMPORT'
            | translate
              : {
                  totalError: totalFailRecords,
                  totalRecord: totalRecords,
                  filename: title
                }
        "
      ></p>
    </div>
    <div class="flex m-3">
      <app-cancel-button class="ml-auto mr-3" (onClick)="onCancel()">
      </app-cancel-button>
      <app-base-button
        [label]="buttonText?.exportErrorBtn || 'EXPORT'"
        (onClick)="exportErrorFile()"
      ></app-base-button>
    </div>
  </div>
</div>
